import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useSession } from "@/lib/session";
import { ArrowLeft } from "lucide-react";

export default function StudentPicker() {
  const navigate = useNavigate();
  const { setUserId } = useSession();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    api.listUsers("student").then(setStudents);
  }, []);

  return (
    <div className="student-view min-h-screen bg-background p-8">
      <button onClick={() => navigate("/")} className="text-muted-foreground inline-flex items-center gap-1 hover:text-foreground" data-testid="back-btn">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <div className="max-w-3xl mx-auto mt-12 text-center space-y-10">
        <div>
          <h1 className="text-5xl font-black mb-3">Who&apos;s tracing today?</h1>
          <p className="text-muted-foreground text-lg">Tap your name to start.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-6" data-testid="student-list">
          {students.map(s => (
            <button
              key={s.id}
              data-testid={`student-card-${s.name.toLowerCase()}`}
              onClick={() => { setUserId(s.id); navigate(`/student/${s.id}`); }}
              className="rounded-3xl bg-white border border-border p-8 flex items-center gap-5 hover:border-orange-500 transition min-h-[120px]"
            >
              <img src={s.avatar} alt="" className="h-20 w-20 rounded-2xl object-cover bg-sky-100" />
              <div className="text-left">
                <div className="text-2xl font-black">{s.name}</div>
                <div className="text-muted-foreground">Tap to play</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
